import React from "react";
import ReactApexChart from "react-apexcharts";
import dayjs from "dayjs";

const ScoreBarChart = ({ data, label, selectedOption2 }) => {
  console.log("🚀 ScoreBarChart data:", data);

  // Determine the type of data
  const isYearly =
    data?.data?.[0]?._id?.year !== undefined &&
    data?.data?.[0]?._id?.week === undefined; // Yearly data includes year but not week
  const isMonthly =
    data?.data?.[0]?.weekStartDate !== undefined &&
    data?.data?.[0]?._id?.week !== undefined; // Weekly data with week and weekStartDate
  const isWeekly =
    data?.data?.[0]?._id && typeof data?.data?.[0]?._id === "string"; // Weekly data has _id as a string

  // Prepare chart categories
  const categories = isYearly
    ? data?.data?.map((item) => item?.month) // Yearly: Use month names
    : isMonthly
    ? data?.data?.map(
        (item) =>
          `${dayjs(item?.weekStartDate).format("MMM D")} - ${dayjs(
            item?.weekEndDate
          ).format("MMM D")}` // Weekly: Format as "MMM D - MMM D"
      )
    : isWeekly
    ? data?.data?.map((item) => dayjs(item?._id).format("MMM D")) // Weekly: Format as "MMM D"
    : [dayjs().format("MMM D")];

  // Prepare series data
  const seriesData = data?.data?.map(
    (item) =>
      item?.datas?.scoreAvg ||
      item?.datas?.hitsAvg ||
      item?.datas?.passingAvg ||
      0 // Default to 0 if no data
  );

  const chartData = {
    series: [
      {
        data: seriesData,
      },
    ],
    options: {
      chart: {
        type: "bar",
        height: 350,
        toolbar: {
          show: true,
          tools: {
            download: false,
          },
        },
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          borderRadiusApplication: "end",
          horizontal: false,
          dataLabels: {
            position: "top", // top, center, bottom
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetY: -20,
        style: {
          fontSize: "12px",
          colors: ["#FFFFFF"],
        },
        formatter: (val) => val, // Handle missing values
      },
      xaxis: {
        categories: categories,
        labels: {
          style: {
            colors: "#FFFFFF",
          },
        },
        axisBorder: {
          color: "#FFFFFF",
        },
        axisTicks: {
          color: "#FFFFFF",
        },
      },
      yaxis: {
        labels: {
          style: {
            colors: "#FFFFFF",
          },
        },
      },
      grid: {
        borderColor: "rgba(255, 255, 255, 0.1)",
      },
      fill: {
        colors: ["#6DD37F"],
      },
      tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          const gameData = data?.data?.[dataPointIndex]?.datas;
          const averageScore = series[seriesIndex][dataPointIndex] || "N/A";
          const totalGames = gameData?.games || "N/A";
          const totalScore =
            gameData?.scoreTotal ||
            gameData?.hitsTotal ||
            gameData?.passingTotal ||
            "N/A";
          const category = w.globals.labels[dataPointIndex]; // Fetch the category (e.g., month)

          return `
            <div style="padding: 8px; background-color: #1E1E2F; color: #FFFFFF; border-radius: 4px;">
              <div><strong>${category}</strong></div>
              <div style="border-bottom: 1px solid #FFFFFF; margin: 4px 0;"></div> <!-- Horizontal border -->
              <div>Average ${selectedOption2}: ${averageScore}</div>
              <div>Total games: ${totalGames}</div>
              <div>Total ${selectedOption2}: ${totalScore}</div>
            </div>
          `;
        },
      },
    },
  };

  return (
    <div>
      {/* <p className="text-white text-base font-bold text-center">
        Average <span className="capitalize"> {`${selectedOption2}`}</span> per
        {isYearly
          ? " year"
          : isMonthly
          ? " month"
          : isWeekly
          ? " week"
          : " day"}
      </p> */}
      <p className="text-white text-base font-bold text-center">
        Average <span> {`${selectedOption2}`}</span> per month
      </p>
      <div id="chart">
        {data?.data?.length > 0 ? (
          <ReactApexChart
            options={chartData.options}
            series={chartData.series}
            type="bar"
            height={350}
          />
        ) : (
          <div className="flex justify-center text-white py-10">
            <p>Data Not Found</p>
          </div>
        )}
      </div>
      <div id="html-dist"></div>
    </div>
  );
};

export default ScoreBarChart;
